import styled from "styled-components";
import { COLORS, responsive } from "../../../../../../styles/constants.style";
import {
  fontWeightBold,
  h3Regular,
} from "../../../../../../components/typography/MuiTypography.style";

export const FeesAndExpenseMainWrapper = styled.div`
  margin-top: 16px;
  .fees-and-expense-container {
    margin: 16px;
    ${responsive.MOBILE`
      margin: 0px;
    `}
    .add-fee-expense-btns {
      display: flex;
      justify-content: flex-end;
      column-gap: 16px;

      .divider {
        width: 1px;
        background-color: ${COLORS.cirrus_black3};
      }

      ${responsive.MOBILE`
        flex-direction: column;
        align-items: stretch;
        padding: 16px 8px 12px;
        gap: 8px;
        display: flex;
        flex-direction: column;
      `}
    }
  }

  .add-fees-and-expense-general-form {
    margin: 16px;
  }
  .invoice-amount {
    padding: 0px;
    margin: 0px;
  }
`;

export const AddFeesAndExpenseTabWrapper = styled.div`
  .form-container,
  .radio-container {
    margin: 16px;
  }

  .summary-header {
    padding: 16px;
    border-bottom: 1px solid ${COLORS.cirrus_black3};
  }

  .summary-table-container {
    .text-right {
      text-align: right;
    }
    margin-top: 16px;
  }

  .fee-selection-type-radio-group {
    ${responsive.MOBILE`
      .MuiFormControlLabel-root {
        margin-right: 0;
        overflow: hidden;

        .MuiFormControlLabel-label {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    `}
  }
`;

export const ExpenseGenericFormWrapper = styled.div`
  .MuiPickersInputBase-root,
  .date-field {
    width: 100%;
  }
  .form-section {
    &:not(:last-child, :first-child) {
      border-bottom: 1px dashed ${COLORS.primary_light_blue};
    }
    .form-section-header {
      margin-bottom: 16px;
    }
    padding: 24px 16px;

    ${responsive.MOBILE`
      padding: 16px;
    `}
  }
  .exchange-rate-input {
    position: relative;
  }

  .convert-link {
    ${h3Regular}
    ${fontWeightBold}
    position: absolute;
    top: 0px;
    text-decoration: underline;
    text-underline-offset: 4px;
    right: 0px;
    color: ${COLORS.primary_light_blue};
  }

  .fees-expense-comment-box .MuiInputBase-root.MuiOutlinedInput-root {
    padding-top: 24px;
  }
`;
